module.exports = __webpack_public_path__ + "static/media/Howling at the Moon - Instrumental Version.2630385c.jpg";